module.exports = __webpack_public_path__ + "static/media/btn_copy.ce53e087.svg";